import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, Add as AddIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getCraftsmen } from '../../data/Craftsman/actions';

class Craftsman extends PureComponent {
    static propTypes = {
        getCraftsmen: PropTypes.func.isRequired,
        Craftsmen: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshCraftsmen();
    }

    refreshCraftsmen = () => {
        const { getCraftsmen } = this.props;
        this.setState({ loading: true });
        return getCraftsmen()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `craftsman/detail/${rowData.craftsmanId}` });
    };
    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'craftsman/add' });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.craftsman.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshCraftsmen
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate(`generic.craftsman.table.globalAction.add.tooltip`),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderData = memoizeOne(Craftsmen => {
        let result = [];

        Craftsmen.map((Craftsman, CraftsmanId) => {
            result.push({
                craftsmanId: parseInt(CraftsmanId),
                label: Craftsman.get('label'),
                lastname: Craftsman.get('lastname'),
                firstname: Craftsman.get('firstname'),
                craftsmanType: Craftsman.get('craftsmanType'),
                isActive: Craftsman.get('isActive')
                    ? Translator.translate('general.craftman-active')
                    : Translator.translate('general.craftman-inactive')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.craftsmanId'),
                name: 'craftsmanId',
                defaultSort: 'asc',
                width: 90,
                fixedLeft: true
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.craftsmanType'),
                name: 'craftsmanType'
            },
            {
                title: Translator.translate('general.table.column.isActive'),
                name: 'isActive',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.craftman-active') ? classes.enabled : classes.disabled}>
                            {value}
                        </span>
                    );
                }
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { profile, Craftsmen } = this.props;

        return (
            <FHETable
                idTable="craftsmanList"
                columns={this.renderColumns(profile)}
                data={this.renderData(Craftsmen)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.craftsman.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.craftsman.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;

    let Craftsmen = state.environments[history.environment].data.Craftsmen.get('list');
    return {
        profile: state.data.user,
        Craftsmen,
        initialized: state.environments[history.environment].data.Craftsmen.get('initialized')
    };
}

const styles = theme => ({
    enabled: {
        color: theme.palette.success.main
    },
    disabled: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Craftsman/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getCraftsmen }), dispatch)
        )(withStyles(styles, { withTheme: true })(Craftsman))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Craftsman/index.js